'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _GlobalApi = require('@/libs/GlobalApi');

var _GlobalApi2 = _interopRequireDefault(_GlobalApi);

var _MessageList = require('./MessageList');

var _MessageList2 = _interopRequireDefault(_MessageList);

var _NetworkSettings = require('./NetworkSettings');

var _NetworkSettings2 = _interopRequireDefault(_NetworkSettings);

var _ChannelList = require('./ChannelList');

var _ChannelList2 = _interopRequireDefault(_ChannelList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        MessageList: _MessageList2.default,
        NetworkSettings: _NetworkSettings2.default,
        ChannelList: _ChannelList2.default
    },
    props: ['network'],
    data: function data() {
        return {
            pluginUiElements: _GlobalApi2.default.singleton().serverViewPlugins
        };
    },
    computed: {
        hasMessages: function hasMessages() {
            return this.network.serverBuffer().getMessages().length > 0;
        },
        serverBuffer: function serverBuffer() {
            return this.network.serverBuffer();
        },
        restrictedServer: function restrictedServer() {
            return this.$state.setting('restricted');
        },
        networkConnected: function networkConnected() {
            return this.network.state === 'connected';
        }
    },
    watch: {
        networkConnected: function networkConnected() {
            var _this = this;

            this.$nextTick(function () {
                _this.$refs.tabs.a++;
            });
        }
    },
    created: function created() {
        var _this2 = this;

        this.listen(this.$state, 'server.tab.show', function (tabName) {
            _this2.showTab(tabName);
        });
    },

    methods: {
        showTab: function showTab(tabName) {
            this.$refs.tabs.setActiveByName(tabName);
        },
        tabChanged: function tabChanged(tabName) {
            this.serverBuffer.show_input = tabName === 'messages';
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/customized-core/ServerView.vue
// module id = obqe
// module chunks = 1